import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3cd655cc")

_pushScopeId("data-v-3cd655cc")
const _hoisted_1 = { class: "list-wrap" }
const _hoisted_2 = { class: "select-all-wrap" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "选择同步账户",
    modelValue: _ctx.isShowDialog,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowDialog = $event)),
    width: 470,
    onClose: _ctx.close
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.confirm,
          loading: _ctx.loading
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick", "loading"]),
        _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_el_checkbox, {
            indeterminate: _ctx.isIndeterminate,
            modelValue: _ctx.checkAll,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkAll = $event)),
            onChange: _ctx.handleCheckAllChange
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["indeterminate", "modelValue", "onChange"])
        ]),
        _createVNode(_component_el_checkbox_group, {
          modelValue: _ctx.checkedList,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkedList = $event))
        }, {
          default: _withId(() => [
            _createVNode("ul", _hoisted_4, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                return (_openBlock(), _createBlock("li", {
                  key: item.criteo_advertiser_id
                }, [
                  _createVNode(_component_el_checkbox, {
                    label: item.criteo_advertiser_id,
                    onChange: _ctx.checkedChange
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(item.criteo_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "onChange"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClose"]))
})